import { BlockStack, Card, Layout, SkeletonBodyText } from '@shopify/polaris';
import { memo } from 'react';

function BaseSkeletonLayoutWithCard() {
  return (
    <Layout>
      <Layout.Section>
        <BlockStack gap={'400'}>
          <Card>
            {/* <SkeletonBodyText lines={14} /> */}
            <SkeletonBodyText lines={2} />
          </Card>
          <Card>
            {/* <SkeletonBodyText lines={19} /> */}
            <SkeletonBodyText lines={2} />
          </Card>
          <Card>
            {/* <SkeletonBodyText lines={45} /> */}
            <SkeletonBodyText lines={2} />
          </Card>
          <Card>
            {/* <SkeletonBodyText lines={5} /> */}
            <SkeletonBodyText lines={2} />
          </Card>
          <Card>
            {/* <SkeletonBodyText lines={9} /> */}
            <SkeletonBodyText lines={2} />
          </Card>
        </BlockStack>
      </Layout.Section>
      <Layout.Section variant="oneThird">
        <BlockStack gap={'400'}>
          <Card>
            <SkeletonBodyText lines={26} />
          </Card>
          <Card>
            <SkeletonBodyText lines={2} />
          </Card>
        </BlockStack>
      </Layout.Section>
    </Layout>
  );
}

export default memo(BaseSkeletonLayoutWithCard);
